"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  input: {
    marginTop: theme.spacing(2)
  },
  linkAlqa: {
    alignSelf: 'flex-end'
  },
  linkAlqaSpan: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  tooltip: {
    marginTop: 'auto',
    textAlign: 'center',
    '& .MuiIconButton-root': {
      padding: 0
    }
  }
});

exports.default = _default;